import { Block, TExtendedBlockProps } from "kanopi-components/Block";
import * as React from "react";

// Would like for this to be around FormControls by default, but some of our
// Inputs from the InputRegistry do not wrap themselves in a FormControl, so
// a standard margin would not propagate from there. May need to make them uniform?

type TInputWrapperProps = {
  children: React.ReactNode;
  restProps?: TExtendedBlockProps;
};

export const InputWrapper: React.FC<TInputWrapperProps> = ({
  children,
  ...restProps
}) => (
  <Block marginBottom={["scale600", "scale800"]} {...restProps}>
    {children}
  </Block>
);
